import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore, memoizeSelector } from '@core/ngrx-legacy';
import { OfferKind, OfferStatus } from '@core/offers-types';
import type { TalentPoolBrief } from '@core/talent-pools-types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<TalentPoolBrief>()(
  'TalentPoolsBrief',
  {
    customActions: adapter => ({
      upsertOne: (state, payload: { data: TalentPoolBrief }) =>
        adapter.upsertOne(state, payload.data, {}),
      upsertMany: (state, payload: { data: TalentPoolBrief[] }) =>
        adapter.upsertMany(state, payload.data, {}),
      references: (state, payload: { data: TalentPoolBrief[] }) => {
        const entities = payload.data.map(entity => ({
          ...entity,
          kind: OfferKind.TalentPool,
        }));
        return adapter.updateOrCreateMany(state, entities);
      },
    }),
  },
);

const TalentPoolsBriefSelectors = {
  ...selectors,
  default: memoizeSelector(() =>
    createSelector(selectors.entities(), entities =>
      entities.filter(entity => entity.status === OfferStatus.Draft),
    ),
  ),
  archived: memoizeSelector(() =>
    createSelector(selectors.entities(), entities =>
      entities.filter(entity => entity.status === OfferStatus.Archived),
    ),
  ),
  entitiesByIds: memoizeSelector((ids: number[]) =>
    createSelector(selectors.entities(), entities =>
      entities.filter(entity => ids.includes(entity.id)),
    ),
  ),
};

export {
  TalentPoolsBriefSelectors,
  actions as TalentPoolsBriefActions,
  reducer as TalentPoolsBriefReducer,
  namespace as TalentPoolsBriefNamespace,
};
